// extracted by mini-css-extract-plugin
export default {"textArea":"MyPopModal_textArea__CuJIj","popupmodel_holder":"MyPopModal_popupmodel_holder__OZ+c9","modalBackdrop":"MyPopModal_modalBackdrop__vSZeX"};